import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./ui/app/App"
import reportWebVitals from "./reportWebVitals"
import { Theme, presetGpnDefault } from "@consta/uikit/Theme"


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
    <React.StrictMode>
        <Theme preset={presetGpnDefault}>
            <App />
        </Theme>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
